import { MainCol, MainContainer, MainRow } from "components/common";
import { DocumentationWrapper, Title } from "./element";
import { DocumentationCard } from "components/common/card";
import { cardData } from "./data";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
function DocumentationCom() {
  return (
    <>
      <AnimationOnScroll animateIn="animate__bounceIn">
        <Title>Documentation</Title>
      </AnimationOnScroll>
      <DocumentationWrapper id="docs">
        <MainContainer>
          <MainRow>
            {cardData?.map((item) => (
              <MainCol lg={4} className="d-flex justify-content-center">
                <AnimationOnScroll animateIn="animate__fadeInUp">
                  <DocumentationCard item={item} />
                </AnimationOnScroll>
              </MainCol>
            ))}
          </MainRow>
        </MainContainer>
      </DocumentationWrapper>
    </>
  );
}

export default DocumentationCom;
